// extracted by mini-css-extract-plugin
module.exports = {"portal":"portal_portal__h0tVA"};